import {register} from '../vendor/theme-scripts/theme-sections';
import {popoutSection} from '../features/popout';
import hideElement from '../util/hide-element';
import slideDown from '../util/slide-down';
import fadeIn from '../util/fade-in';
import tabs from '../features/tabs';
import {QuickAddProduct} from '../features/quick-add';
import {makeGridSwatches} from '../features/swatch';

const selectors = {
  dataRelatedSectionElem: '[data-related-section]',
  dataRelatedProduct: '[data-product-grid-item]',
  dataProductId: 'data-product-id',
  dataLimit: 'data-limit',
  recentlyViewed: '#RecentlyViewed',
  recentlyProduct: '#recently-viewed-products .product-item',
};

class Related {
  constructor(section) {
    this.section = section;
    this.container = section.container;

    this.init();
    this.recent();
  }

  init() {
    const relatedSection = this.container.querySelector(selectors.dataRelatedSectionElem);

    if (!relatedSection) {
      return;
    }

    const self = this;
    const productId = relatedSection.getAttribute(selectors.dataProductId);
    const limit = relatedSection.getAttribute(selectors.dataLimit);
    const requestUrl = `${window.theme.routes.product_recommendations_url}?section_id=related&limit=${limit}&product_id=${productId}`;

    fetch(requestUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (data) {
        const createdElement = document.createElement('div');
        createdElement.innerHTML = data;
        const inner = createdElement.querySelector(selectors.dataRelatedSectionElem);

        if (inner.querySelector(selectors.dataRelatedProduct)) {
          const innerHtml = inner.innerHTML;
          hideElement(relatedSection);
          relatedSection.innerHTML = innerHtml;
          slideDown(relatedSection);

          relatedSection.querySelectorAll(selectors.dataRelatedProduct).forEach((item) => {
            new QuickAddProduct(item);
          });

          makeGridSwatches(self.section);
        } else {
          self.container.dispatchEvent(
            new CustomEvent('tabs:hideRelatedTab', {
              bubbles: true,
            })
          );
        }
      })
      .catch(function () {
        self.container.dispatchEvent(
          new CustomEvent('tabs:hideRelatedTab', {
            bubbles: true,
          })
        );
      });
  }

  recent() {
    const recentlyViewed = this.container.querySelector(selectors.recentlyViewed);
    let howManyToshow = 4;

    if (recentlyViewed) {
      howManyToshow = parseInt(recentlyViewed.getAttribute(selectors.dataLimit));
      Shopify.Products.recordRecentlyViewed();
    }

    Shopify.Products.showRecentlyViewed({
      howManyToShow: howManyToshow,
      onComplete: () => {
        const recentProductsCount = this.container.querySelectorAll(selectors.recentlyProduct).length;

        if (recentProductsCount > 0) {
          fadeIn(recentlyViewed);

          this.container.dispatchEvent(
            new CustomEvent('tabs:checkRecentTab', {
              bubbles: true,
            })
          );

          this.container.querySelectorAll(selectors.recentlyProduct).forEach((item) => {
            new QuickAddProduct(item);
          });

          makeGridSwatches(this.section);
        }
      },
    });
  }
}

const relatedSection = {
  onLoad() {
    this.section = new Related(this);

    this.container.querySelectorAll(selectors.dataRelatedProduct).forEach((item) => {
      new QuickAddProduct(item);
    });
  },
};

register('related', [relatedSection, popoutSection, tabs]);
